/* Theater layout: top bar over a [stage | sidebar] row. */
.room {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  background: var(--color-bg);
}

.topbar {
  display: flex;
  align-items: center;
  gap: var(--space-5);
  padding: 0 var(--space-5);
  height: 52px;
  flex-shrink: 0;
  background: var(--color-bg);
  border-bottom: 1px solid var(--color-border);
}

.nowPlaying {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}

.nowPlayingLabel {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-text-subtle);
}

.nowPlayingTitle {
  font-size: var(--fs-sm);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.body {
  flex: 1;
  display: flex;
  min-height: 0;
}

/* ── Fullscreen + Chat mode ────────────────────────────────────────────────── */
/* WHY: when the room container is in browser fullscreen, the video stage fills
   the screen and the sidebar floats as a semi-transparent overlay on the right. */
.roomFs {
  background: #000;
}

.roomFs .body {
  position: relative;
}

.roomFs .stage {
  flex: 1 1 100%;
  min-width: 0;
  height: 100%;
  padding: 0;
  gap: 0;
}

.roomFs .status {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  padding: 4px 10px;
  border-radius: var(--radius-md);
  backdrop-filter: blur(4px);
}

.loading,
.error {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--space-4);
  flex: 1;
}

.stage {
  flex: 1 1 auto;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #000;
  min-height: 0;
  position: relative;
}

.status {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.fsChatBtn {
  background: rgba(255, 255, 255, 0.12);
  border: 0;
  border-radius: var(--radius-sm);
  width: 32px;
  height: 28px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text);
  transition: transform 60ms var(--ease-out), background var(--motion-fast) var(--ease-out);
}

.fsChatBtn:hover {
  background: rgba(255, 255, 255, 0.22);
}

.fsChatBtn:active {
  transform: scale(0.88);
}

.error {
  padding: var(--space-6);
  text-align: center;
  background: radial-gradient(ellipse 60% 40% at 50% 0%, rgba(229, 9, 20, 0.2), transparent 70%), var(--color-bg);
}

.errorTitle {
  font-size: clamp(24px, 5vw, 36px);
  font-weight: 800;
  letter-spacing: -0.02em;
}

.errorText {
  color: var(--color-text-muted);
  font-size: var(--fs-md);
  max-width: 40ch;
}

.backBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 var(--space-6);
  border-radius: var(--radius-sm);
  background: var(--color-accent);
  color: var(--color-accent-contrast);
  font-weight: 700;
  transition: transform 60ms var(--ease-out), background var(--motion-fast) var(--ease-out);
}

.backBtn:hover {
  background: var(--color-accent-hover);
  text-decoration: none;
}

.backBtn:active {
  transform: scale(0.95);
}

/* ── Tablet / phone: video pinned on top, chat fills the rest ───────────────── */
@media (max-width: 900px) {
  .topbar {
    height: 48px;
    gap: var(--space-3);
    padding: 0 var(--space-3);
    padding-top: env(safe-area-inset-top);
    box-sizing: content-box;
  }
  .nowPlayingLabel {
    display: none;
  }
  .nowPlaying {
    flex: 1 1 0;
  }
  .topbar :global(.spacer) {
    display: none;
  }
  .body {
    flex-direction: column;
    overflow: hidden;
  }
  .stage {
    flex: 0 0 auto;
    min-width: 0;
    width: 100%;
  }
}
